(function() {
  var EL, TAGS_ROOT, TRIGGER, TICK = null;

  function getEls() {
    EL = document.getElementById('mk-disclaimer-2');
    TAGS_ROOT = document.getElementById('mk-cart-tags');
    TRIGGER = EL ? (EL.getAttribute('data-trigger-tag') || '') : '';
  }

  function cartHasTriggerTag() {
    if (!TAGS_ROOT || !TRIGGER) return false;
    var items = TAGS_ROOT.querySelectorAll('[data-product-tags]');
    for (var i = 0; i < items.length; i++) {
      var tags = (items[i].getAttribute('data-product-tags') || '').toLowerCase();
      var arr = tags.split(',').map(function(t){ return t.trim(); }).filter(Boolean);
      if (arr.indexOf(TRIGGER.toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function show(el) {
    el.classList.remove('is-hidden');
    el.removeAttribute('hidden');
    el.style.display = ''; // Inline-Hide killen
    el.setAttribute('aria-hidden', 'false');
  }

  function hide(el) {
    el.classList.add('is-hidden');
    el.setAttribute('hidden', '');
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
  }

  function toggleDisclaimer() {
    if (!EL) return;
    var shouldShow = cartHasTriggerTag();
    if (shouldShow) show(EL); else hide(EL);
  }

  function debounce(fn, delay) {
    var id; return function(){ clearTimeout(id); id = setTimeout(fn, delay); };
  }

  function initObserver() {
    if (!TICK) {
      TICK = setInterval(function(){
        getEls(); // falls DOM ersetzt wurde
        toggleDisclaimer();
      }, 1500);
    }
    var mo = new MutationObserver(debounce(function(){
      getEls(); toggleDisclaimer();
    }, 150));
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ getEls(); toggleDisclaimer(); initObserver(); });
  } else {
    getEls(); toggleDisclaimer(); initObserver();
  }
})();
